var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value && _vm.value[_vm.identifier])?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"mr-2"},[_c('app-icon',{staticClass:"primary-text-color",attrs:{"name":_vm.icon,"width":"16","height":"16"}})],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value[_vm.identifier]))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }